import { NextSeo } from 'next-seo'

import bottomImg from '@/assets/illustrations/our-usp.svg'
import Button, { ButtonVariant } from '@/components/button'
import Link from '@/components/link'

const OurUsp = () => {
  return (
    <div className='align-center  flex h-[100%] min-h-full  flex-wrap bg-theme-turquoise px-5'>
      <NextSeo title='Our USP' />
      <div className='py-custom pt-custom-150 mt-3 flex-[0_0_100%] '>
        <div className='mx-auto flex h-full max-w-[566px] flex-wrap content-between pl-9 pr-12'>
          <div className='flex-no-wrap mb-5 flex h-fit w-full items-center justify-between'>
            <div>
              <Link
                href='/about'
                className='custom-font-body !font-bold text-black'
              >
                ABOUT US
              </Link>
            </div>
            <div>
              <Button
                variant={ButtonVariant.Primary}
                bg='bg-[#F59175]'
                tailFill='#F59175'
                className='cm-bg custom-font-body !rounded-4xl !px-2 !py-2 !font-bold text-black'
                tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
              >
                <span className='translate-y-0.5'>OUR USP</span>
              </Button>
            </div>
            <div>
              <Link
                href='/team'
                className='custom-font-body !font-bold text-black'
              >
                TEAM
              </Link>
            </div>
          </div>
          <div className='w-full py-10'>
            <img src={`${bottomImg.src}`} className='m-auto' />
          </div>
          <div className='py-10'>
            <p className='custom-font-body mb-10'>
              All of us, cognitively know what is needed to be done to reach an
              emotionally stable state. "I need to stop stressing", "I need to
              think positive", "I should not let other's POV bother me", etc
            </p>
            <p className='custom-font-body mb-10 underline'>
              Thrive Café brings the 'How' to our motivations and goals. It is a
              bridge that teaches a sustainable way to move from emotional
              unrest towards clarity & calm.
            </p>
            <p className='custom-font-body'>
              <span className=''>
                Each Thrive Skill curriculum is backed by scientific frameworks
                and research. It is the curriculum, the content, practises and
                exercises that make it simple and easy to apply into our lives;
                so we can
              </span>{' '}
              start making everyday better in small incremental ways.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default OurUsp
